/* eslint-disable no-unused-vars */

import apiClient from '@u/apiClient'
import SearchGlobalController from '@/wayfinder/actions/App/Http/Controllers/SearchGlobal/SearchGlobalController'

const base_errors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  getGlobalSearchResult({ commit }, payload) {
    //commit('setSearchResult', payload)
    return new Promise((resolve, reject) => {
      apiClient
        .route(SearchGlobalController.get(), {
          params: {
            terms: payload.terms,
            longitude: payload.longitude,
            latitude: payload.latitude
          }
        })
        .then((response) => {
          // commit('setSearchResult', response.data)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
